export const testIds = {
  placementsStatus: {
    placementsList: {
      placementsListId: 'placement-list-container-id',
      card: {
        checkbox: 'placement-list-card-checkbox-test-id',
      },
    },
    modalCall: {
      modal: 'placement-status-modal-test-id',
      datepicker: 'placement-status-modal-datepicker-test-id',
    },
    placementItem: 'placement-status_placement-item-test-id',
  },
  schesuleTransferDetails: {
    statistics: {
      card: {
        cardContainer: 'schesuleTransferDetails-statistics-card-id',
      },
    },
  },
  filters: {
    filterBlock: 'filter-block-test-id',
  },
};
